import { Facility } from '@reliance/types/models/Facility';
import { FORM_ERROR } from 'final-form';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Form } from 'react-final-form';
import { alertStore } from '../alert/alertStore';
import api from '../common/api';
import { TextArea } from '../form/TextArea';

type EditCallingProps = {
  facility: Facility;
  onSave(): any;
};

const EditCalling: React.FC<EditCallingProps> = (props) => {
  const initialValues = {
    dialingInstructions: props.facility.dialingInstructions
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(formData) =>
        api.put(`/facility/${props.facility.id}`, formData)
          .then(() => alertStore.success('Facility was successfully saved'))
          .then(() => localStorage.removeItem('cachedFacilities'))
          .catch((err) => ({ [FORM_ERROR]: err }))
      }
      render={(form) =>
        <form onSubmit={form.handleSubmit}>
          <Card>
            <Card.Body>
              <TextArea
                rows={3}
                label="Dialing Instructions"
                name="dialingInstructions" />
            </Card.Body>
            <Card.Footer>
              <Button
                variant="primary"
                disabled={form.submitting || form.hasValidationErrors}
                type="submit">
                Save
              </Button>
            </Card.Footer>
          </Card>
        </form>
      } />
  );
};

export default EditCalling;
